import { hooks } from '@atlassian/mpac-utils';
import { useEffect, useState } from 'react';
import { getExistingCommunityQuestionsCount, makeAskNewQuestionUrl, makeSeeExistingQuestionsUrl } from '../utils';
const {
  usePromise
} = hooks;
export const useCommunityQuestionLink = options => {
  const {
    mpacBaseUrl,
    atlassianCommunityBaseUrl,
    hosting,
    appKey
  } = options;
  const [communityLink, setCommunityLink] = useState({
    url: makeAskNewQuestionUrl({
      appKey,
      atlassianCommunityBaseUrl,
      hosting
    }),
    type: 'new'
  });
  const {
    result,
    pending
  } = usePromise(() => getExistingCommunityQuestionsCount({
    mpacBaseUrl,
    appKey
  }));
  useEffect(() => {
    if (typeof result === 'number' && result > 0) {
      setCommunityLink({
        url: makeSeeExistingQuestionsUrl({
          appKey,
          atlassianCommunityBaseUrl
        }),
        type: 'existing'
      });
    }
  }, [result, pending]);
  return communityLink;
};